"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Username = exports.PopupLink = exports.PopupContentGroup = exports.PopupButton = exports.OrderContent = exports.BackArrow = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _constants = require("../../../TopAreaBanner/constants");
const BackArrow = exports.BackArrow = (0, _mui.styled)(_mui.SvgIcon)(({
  theme
}) => ({
  cursor: 'pointer',
  position: 'absolute',
  left: theme.spacing(3),
  top: theme.spacing(3)
}));
const OrderContent = exports.OrderContent = (0, _mui.styled)('div')(({
  theme
}) => ({
  textAlign: 'center',
  margin: '0 auto',
  color: theme.palette.common.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  span: {
    lineHeight: theme.typography.pxToRem(_constants.TOP_AREA_BANNER_HEIGHT),
    textTransform: 'uppercase',
    fontSize: '1rem'
  },
  svg: {
    height: '2rem'
  },
  'svg:first-of-type': {
    marginRight: theme.spacing(1)
  },
  'svg:last-of-type': {
    marginLeft: theme.spacing(1)
  }
}));
const Username = exports.Username = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textDecoration: 'underline',
  color: theme.palette.common.white,
  marginLeft: theme.spacing(1),
  cursor: 'pointer'
}));
const PopupContentGroup = exports.PopupContentGroup = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginTop: theme.spacing(3)
}));
const PopupButton = exports.PopupButton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  marginBottom: theme.spacing(3)
}));
const PopupLink = exports.PopupLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  marginBottom: theme.spacing(3),
  textAlign: 'center',
  color: theme.palette.common.black
}));
